// Updated labels for Condo only

const labels = {
  GarageNumberOfCars: "Parking Spaces",
}

export default labels;
